import { Card, CardContent, CardHeader, CardTitle } from '@/components/Card'
import { Button } from '@/components/Button'
import styles from './TasksCard.module.css'
import { NoTaskList } from './NoTaskList'

export interface TasksCardProps {
  canCloseAsCollaborator: boolean
  onCompleteJob: () => unknown
  testId?: string
  titleTestId?: string
  completeButtonTestId?: string
  emptyTestId?: string
}

export function TasksCard({
  canCloseAsCollaborator,
  onCompleteJob,
  testId,
  titleTestId,
  completeButtonTestId,
  emptyTestId,
}: TasksCardProps) {
  return (
    <Card testId={testId}>
      <CardHeader compactBottomPadding>
        <CardTitle testId={titleTestId}>Current task</CardTitle>
      </CardHeader>
      <CardContent>
        <NoTaskList testId={emptyTestId} />
      </CardContent>
      {canCloseAsCollaborator && (
        <CardContent>
          <Button
            label="Complete Job"
            testId={completeButtonTestId}
            className={styles.completeButton}
            onPress={onCompleteJob}
          />
        </CardContent>
      )}
    </Card>
  )
}
